import { render, staticRenderFns } from "./wechatMarkRecord.vue?vue&type=template&id=5bce1c66&scoped=true"
import script from "./wechatMarkRecord.vue?vue&type=script&lang=js"
export * from "./wechatMarkRecord.vue?vue&type=script&lang=js"
import style0 from "./wechatMarkRecord.vue?vue&type=style&index=0&id=5bce1c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bce1c66",
  null
  
)

export default component.exports